// @ts-ignore
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../store/userSlice";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LOGO from "../assets/images/newLogo.png";
import APPNAME from "../assets/images/appname.png";
import { Eye, EyeOff } from "lucide-react";

const LoginScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // @ts-ignore
  const { loading } = useSelector((state) => state.user);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.toLowerCase());

  const handleEmailLogin = async () => {
    if (!email || !password) {
      toast.error("Please enter email and password");
      return;
    }

    if (!isValidEmail(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      // @ts-ignore
      const userData = await dispatch(loginUser({ email, password })).unwrap();

      console.log(userData);

      if (userData?.profileCompleted === "no") {
        navigate("/complete-profile", {
          state: { student_athlete_id: userData.user_id },
        });
        return;
      }

      // toast.success(`Welcome, ${userData?.username}`);
    } catch (error) {
      console.error(error);
      toast.error("Login Failed: Invalid credentials or server error.");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="min-h-screen bg-[#121212] flex items-center justify-center px-4">
      <ToastContainer />
      <div className="w-full max-w-md bg-[#1e1e1e] rounded-lg shadow-lg p-8">
        <div className="flex flex-col items-center mb-6">
          <img
            src={LOGO}
            alt="logo"
            className="h-40 w-40 object-contain mb-0"
          />
          <img src={APPNAME} alt="app name" className="h-16 object-contain" />
        </div>

        <div className="space-y-4">
          <input
            type="email"
            placeholder="Email Address"
            className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] text-white placeholder-gray-400 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="relative w-full mb-2">
            {" "}
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] text-white placeholder-gray-400 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10" // Changed: Added pr-10 for icon space
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-200"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}{" "}
            </button>
          </div>
          <button
            onClick={handleEmailLogin}
            disabled={loading}
            className="w-full py-3 rounded-md bg-[#C00000] hover:bg-red-700 text-white font-semibold transition duration-200"
          >
            {loading ? "Signing in..." : "SIGN IN"}
          </button>
        </div>

        <div className="flex flex-col text-center text-white mt-4">
          <button
            onClick={() => navigate("/forgot-password")}
            className="text-sm mr-2"
          >
            Can’t Log In?
          </button>
          {/* <button
            onClick={() => navigate("/register")}
            className="text-[#C00000] hover:underline hover:text-red-700 mt-2 text-sm"
          >
            Register
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
